import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, b as setSearchParams, t as toPathString, s as setBearerAuthToObject, c as serializeDataIfNeeded, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * SalesPersonsApi - axios parameter creator
 * @export
 */
const SalesPersonsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countAll: async (options = {}) => {
            const localVarPath = `/v1/SalesPersons/countAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options = {}) => {
            const localVarPath = `/v1/SalesPersons/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/SalesPersons/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [guid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerOfPasswordResetRequest: async (guid, options = {}) => {
            const localVarPath = `/v1/SalesPersons/GetCustomerOfPasswordResetRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (guid !== undefined) {
                localVarQueryParameter['guid'] = guid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile: async (options = {}) => {
            const localVarPath = `/v1/SalesPersons/GetProfile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {SalesPersonToken} [SalesPersonToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (SalesPersonToken, options = {}) => {
            const localVarPath = `/v1/SalesPersons/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(SalesPersonToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {LoginArgs} [LoginArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (LoginArgs, options = {}) => {
            const localVarPath = `/v1/SalesPersons/Login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(LoginArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RefreshTokenArgs} [RefreshTokenArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (RefreshTokenArgs, options = {}) => {
            const localVarPath = `/v1/SalesPersons/Logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(RefreshTokenArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RefreshTokenArgs} [RefreshTokenArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken: async (RefreshTokenArgs, options = {}) => {
            const localVarPath = `/v1/SalesPersons/RefreshToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(RefreshTokenArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/SalesPersons/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ChangePasswordToken} [ChangePasswordToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (ChangePasswordToken, options = {}) => {
            const localVarPath = `/v1/SalesPersons/ResetPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ChangePasswordToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordRequest: async (email, options = {}) => {
            const localVarPath = `/v1/SalesPersons/ResetPasswordRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {SalesPersonToken} [SalesPersonToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (SalesPersonToken, options = {}) => {
            const localVarPath = `/v1/SalesPersons/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(SalesPersonToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {ChangePasswordToken} [ChangePasswordToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword: async (ChangePasswordToken, options = {}) => {
            const localVarPath = `/v1/SalesPersons/UpdatePassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ChangePasswordToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {SalesPersonToken} [SalesPersonToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile: async (SalesPersonToken, options = {}) => {
            const localVarPath = `/v1/SalesPersons/UpdateProfile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(SalesPersonToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [guid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyRegistration: async (guid, options = {}) => {
            const localVarPath = `/v1/SalesPersons/VerifyRegistration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (guid !== undefined) {
                localVarQueryParameter['guid'] = guid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SalesPersonsApi - functional programming interface
 * @export
 */
const SalesPersonsApiFp = function (configuration) {
    const localVarAxiosParamCreator = SalesPersonsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonsApi.countAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonsApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonsApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [guid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerOfPasswordResetRequest(guid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerOfPasswordResetRequest(guid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonsApi.getCustomerOfPasswordResetRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfile(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfile(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonsApi.getProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {SalesPersonToken} [SalesPersonToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(SalesPersonToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(SalesPersonToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonsApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {LoginArgs} [LoginArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(LoginArgs, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(LoginArgs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonsApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {RefreshTokenArgs} [RefreshTokenArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(RefreshTokenArgs, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(RefreshTokenArgs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonsApi.logout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {RefreshTokenArgs} [RefreshTokenArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshToken(RefreshTokenArgs, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshToken(RefreshTokenArgs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonsApi.refreshToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonsApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ChangePasswordToken} [ChangePasswordToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(ChangePasswordToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(ChangePasswordToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonsApi.resetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPasswordRequest(email, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPasswordRequest(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonsApi.resetPasswordRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {SalesPersonToken} [SalesPersonToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(SalesPersonToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(SalesPersonToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonsApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {ChangePasswordToken} [ChangePasswordToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePassword(ChangePasswordToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePassword(ChangePasswordToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonsApi.updatePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {SalesPersonToken} [SalesPersonToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProfile(SalesPersonToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProfile(SalesPersonToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonsApi.updateProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [guid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyRegistration(guid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyRegistration(guid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesPersonsApi.verifyRegistration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SalesPersonsApi - factory interface
 * @export
 */
const SalesPersonsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SalesPersonsApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countAll(options) {
            return localVarFp.countAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options) {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [guid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerOfPasswordResetRequest(guid, options) {
            return localVarFp.getCustomerOfPasswordResetRequest(guid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile(options) {
            return localVarFp.getProfile(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {SalesPersonToken} [SalesPersonToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(SalesPersonToken, options) {
            return localVarFp.insert(SalesPersonToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {LoginArgs} [LoginArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(LoginArgs, options) {
            return localVarFp.login(LoginArgs, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RefreshTokenArgs} [RefreshTokenArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(RefreshTokenArgs, options) {
            return localVarFp.logout(RefreshTokenArgs, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RefreshTokenArgs} [RefreshTokenArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken(RefreshTokenArgs, options) {
            return localVarFp.refreshToken(RefreshTokenArgs, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ChangePasswordToken} [ChangePasswordToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(ChangePasswordToken, options) {
            return localVarFp.resetPassword(ChangePasswordToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordRequest(email, options) {
            return localVarFp.resetPasswordRequest(email, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {SalesPersonToken} [SalesPersonToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(SalesPersonToken, options) {
            return localVarFp.update(SalesPersonToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {ChangePasswordToken} [ChangePasswordToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword(ChangePasswordToken, options) {
            return localVarFp.updatePassword(ChangePasswordToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {SalesPersonToken} [SalesPersonToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile(SalesPersonToken, options) {
            return localVarFp.updateProfile(SalesPersonToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [guid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyRegistration(guid, options) {
            return localVarFp.verifyRegistration(guid, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SalesPersonsApi - object-oriented interface
 * @export
 * @class SalesPersonsApi
 * @extends {BaseAPI}
 */
class SalesPersonsApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonsApi
     */
    countAll(options) {
        return SalesPersonsApiFp(this.configuration).countAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonsApi
     */
    getAll(options) {
        return SalesPersonsApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonsApi
     */
    getById(id, options) {
        return SalesPersonsApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [guid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonsApi
     */
    getCustomerOfPasswordResetRequest(guid, options) {
        return SalesPersonsApiFp(this.configuration).getCustomerOfPasswordResetRequest(guid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonsApi
     */
    getProfile(options) {
        return SalesPersonsApiFp(this.configuration).getProfile(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {SalesPersonToken} [SalesPersonToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonsApi
     */
    insert(SalesPersonToken, options) {
        return SalesPersonsApiFp(this.configuration).insert(SalesPersonToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LoginArgs} [LoginArgs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonsApi
     */
    login(LoginArgs, options) {
        return SalesPersonsApiFp(this.configuration).login(LoginArgs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {RefreshTokenArgs} [RefreshTokenArgs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonsApi
     */
    logout(RefreshTokenArgs, options) {
        return SalesPersonsApiFp(this.configuration).logout(RefreshTokenArgs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {RefreshTokenArgs} [RefreshTokenArgs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonsApi
     */
    refreshToken(RefreshTokenArgs, options) {
        return SalesPersonsApiFp(this.configuration).refreshToken(RefreshTokenArgs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonsApi
     */
    remove(id, options) {
        return SalesPersonsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ChangePasswordToken} [ChangePasswordToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonsApi
     */
    resetPassword(ChangePasswordToken, options) {
        return SalesPersonsApiFp(this.configuration).resetPassword(ChangePasswordToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [email]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonsApi
     */
    resetPasswordRequest(email, options) {
        return SalesPersonsApiFp(this.configuration).resetPasswordRequest(email, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {SalesPersonToken} [SalesPersonToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonsApi
     */
    update(SalesPersonToken, options) {
        return SalesPersonsApiFp(this.configuration).update(SalesPersonToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {ChangePasswordToken} [ChangePasswordToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonsApi
     */
    updatePassword(ChangePasswordToken, options) {
        return SalesPersonsApiFp(this.configuration).updatePassword(ChangePasswordToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {SalesPersonToken} [SalesPersonToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonsApi
     */
    updateProfile(SalesPersonToken, options) {
        return SalesPersonsApiFp(this.configuration).updateProfile(SalesPersonToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [guid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesPersonsApi
     */
    verifyRegistration(guid, options) {
        return SalesPersonsApiFp(this.configuration).verifyRegistration(guid, options).then((request) => request(this.axios, this.basePath));
    }
}

export { SalesPersonsApi, SalesPersonsApiAxiosParamCreator, SalesPersonsApiFactory, SalesPersonsApiFp };
//# sourceMappingURL=sales-persons-api.js.map
